import { Call, Email, GitHub, LinkedIn } from '@mui/icons-material'
import { Box, Divider, IconButton, Stack, Typography } from '@mui/material'
import React from 'react'

function Footer() {
  return (
    <Box py={{xs: 3, lg: 5}}>
      <Divider />
      <Stack direction={{lg: 'row', sm: 'column'}} gap={{sm: 1}} pt={1} justifyContent={"space-evenly"} alignItems={"center"}>
        <Box component={"a"} display={"flex"} alignItems={"center"} gap={1} href='tel: +8801877391635' sx={{textDecoration: "none", color: "inherit", fontWeight: "500"}}><Call fontSize='small' /> +8801877391635</Box>
        <Box component={"a"} display={"flex"} alignItems={"center"} href='mailto: sidul246@gmail.com' sx={{textDecoration: "none", color: "inherit", fontWeight: "500"}} gap={1}><Email fontSize='small' /> sidul246@gmail.com</Box>
        <Box>
          <IconButton href='https://www.github.com/sidul567' target='_blank' color='inherit'>
            <GitHub />
          </IconButton>
          <IconButton href='https://www.github.com/sidul567' target="_blank" color='inherit'>
            <LinkedIn />
          </IconButton>
        </Box>
      </Stack>
      <Stack direction={"row"} justifyContent={"center"}>
        <Typography variant='h6' fontWeight={"600"}>Copyright &copy; 2023 Sidul Islam Moon</Typography>
      </Stack>
    </Box>
  )
}

export default Footer